// removed by extract-text-webpack-plugin
module.exports = {"modalAmplio":"nominaIG__modalAmplio___g1Ubf","modalSmall":"nominaIG__modalSmall___1P66g","errorModal":"nominaIG__errorModal___1TqOB","divButtonsSuspend":"nominaIG__divButtonsSuspend___24_DW"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/nominas/nominaIG/nominaIG.css
// module id = 754
// module chunks = 0